import { SlideAction, SlideLayout, ViewMode } from '@gripp/shared-ui';
import React, { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AddButton } from '../../shared/components/addButton/addButton';
import { RoutineSubmitSource } from '../assetUtils';
import { AssetRoutineRearrangeColumn } from './asset-routines-rearrange-column';
import { AssetCard } from './assetCard';
import { AssetFilters } from './assetFilters';

export const AssetRoutinesRearrange = () => {
  const { assetId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [requestRoutineVisible, setRequestRoutineVisible] = useState(false);

  if (!assetId) {
    return null;
  }

  const from = location.state?.from;
  const backPath =
    from === RoutineSubmitSource.RoutinesList
      ? `/assets/${assetId}/routines/all`
      : `/assets/${assetId}`;

  const leftColumn = {
    title: 'assets.menu.title',
    mainComponent: <AssetCard assetId={assetId} />,
    headerComponent: <AssetFilters assetId={assetId} />,
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => {
      navigate(backPath);
    },
    disableScroll: true,
  };

  const rightColumn = {
    title: 'topNav.edit',
    mainComponent: (
      <AssetRoutineRearrangeColumn
        assetId={assetId}
        requestRoutineVisible={requestRoutineVisible}
        onRequestRoutineClose={() => setRequestRoutineVisible(false)}
      />
    ),
    headerComponent: (
      <AddButton onPress={() => setRequestRoutineVisible(true)} />
    ),
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => {
      navigate(backPath);
    },
    disableScroll: true,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
